import { createSlice } from '@reduxjs/toolkit';

interface IChatDeptState {
    departments: string[];
    selectedDepartment: string;
}

const initialState: IChatDeptState = {
    departments: [],
    selectedDepartment: ""
  };

const chatDeptSlice = createSlice({
  name: 'chat-dept',
  initialState,
  reducers: {
    addChatDepartments(state, action){
      state.departments = action.payload;
    },
    setChatDepartment(state, action){
      state.selectedDepartment = action.payload;
    }
  }
});

export const { addChatDepartments, setChatDepartment } = chatDeptSlice.actions;
export default chatDeptSlice.reducer;